module.exports = __webpack_public_path__ + "static/img/sales-person.c02344ee.svg";